import { unwrapResult } from '@reduxjs/toolkit'
import { ErrorCode, Country } from '@afterpaytouch/portal-api/types'
import { countrySelector, crossRegionUserSignIn, supportedCountriesSelector } from '../../'
import { CheckoutError, CrossRegionRedirection, CrossRegionUserDetails, TerminalErrorCode } from '../../../model'
import { AsyncAction } from '../../types'

type CheckCrossBorderResult = CrossRegionRedirection | CheckoutError | null

export const checkCrossBorder =
  (country: Country, email?: string, phoneNumber?: string): AsyncAction<CheckCrossBorderResult> =>
  async (dispatch, getState) => {
    const state = getState()
    const supportedCountries = supportedCountriesSelector(state)
    const currentCountry = countrySelector(state)

    if (!supportedCountries.includes(country)) {
      return { error: TerminalErrorCode.UnsupportedMerchantTradingCountry, errorCode: ErrorCode.UnsupportedMerchantTradingCountry }
    }
    if (currentCountry !== country) {
      const request: CrossRegionUserDetails = {
        consumerCountryCode: country,
        // @ts-expect-error: OPERATION BLEED STOPPER
        consumerEmail: email,
        consumerMobile: phoneNumber,
      }
      try {
        return unwrapResult(await dispatch(crossRegionUserSignIn(request)))
      } catch (e) {
        return { error: TerminalErrorCode.UnsupportedMerchantTradingCountry, errorCode: ErrorCode.UnsupportedMerchantTradingCountry } // TODO: should this be a different error code?
      }
    }
    return null
  }
